export class LocalWardAssignment {
    campusWardId?: number;
    campusHomeWardIds: number[];

    constructor(campusHomeWardIds: number[], campusWardId?: number) {
        this.campusHomeWardIds = campusHomeWardIds;
        this.campusWardId = campusWardId;
    }
}